module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Buscar producto...":"Buscar producto...","No hay resultados":"No hay resultados","Para completar una Referencia faltan":"Para completar una Referencia faltan","dígitos":"dígitos"},"en":{"Buscar producto...":"Search product...","No hay resultados":"No results","Para completar una Referencia faltan":"To complete a Reference there are missing","dígitos":"digits"}}')
  delete Component.options._Ctor
}
